export const LOYALTY_BARCODE_PREPAID_PAYMENT_TYPE_ID = null;
export const ALLOW_FREE_ORDER = true;
